import React from "react";
import { useTranslation } from "react-i18next";
import {Modal, ModalHeader, ModalBody, ModalFooter} from "../../../../components/Modal";
import CustomButton from "../../../../components/CustomButton";
import AlertIcon from "../../../../components/Icons/AlertIcon";

interface LateCancellationModalProps {
  onClose: () => void;
  isOpen: boolean;
  coachName: string;
  cancelMeeting: () => void;
}

const LateCancellationModal: React.FC<LateCancellationModalProps> = ({
  onClose,
  isOpen,
  cancelMeeting,
  coachName,
}) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalHeader onClose={onClose}>
        <div className="z-title1">
          {t("late-cancellation-heading")}
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="flex flex-col justify-between ">
          <div className="flex flex-row justify-center">
            <AlertIcon aria-label="Cancel meeting" className="w-12 h-12 mt-3 text-cherry-500!" />
          </div>
          <p className="text-normal text-base mt-6">
            {t("late-cancellation-text")}
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <CustomButton onClick={() => cancelMeeting()} buttonType="dangerBase">
          {t("cancel2")}
        </CustomButton>
      </ModalFooter>
    </Modal>
  );
};

export default LateCancellationModal;
